import axios from "axios";
import { toast } from "sonner";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_URL, timeout: 60000 });

export const TOKEN_KEY = "si_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 && !error.config?.url?.includes("/auth/login")) {
      setToken(null);
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function errorMessage(error, fallback = "Noe gikk galt") {
  const d = error?.response?.data?.detail;
  if (!d) return error?.message || fallback;
  if (typeof d === "string") return d;
  if (d.message) return d.message;
  return JSON.stringify(d);
}

export function toastError(error, fallback) {
  toast.error(errorMessage(error, fallback));
}

// Convenience fetchers for TanStack Query
export const get = (url, params) => api.get(url, { params }).then((r) => r.data);
export const post = (url, body) => api.post(url, body).then((r) => r.data);
export const patch = (url, body) => api.patch(url, body).then((r) => r.data);
export const put = (url, body) => api.put(url, body).then((r) => r.data);
export const del = (url) => api.delete(url).then((r) => r.data);

export function docViewUrl(id) {
  return `${API_URL}/documents/${id}/view?token=${encodeURIComponent(getToken() || "")}`;
}

/** Download an authenticated file (CSV/PDF) – filename from Content-Disposition, else `fallbackName`. */
export async function downloadFile(url, params, fallbackName = "fil") {
  const r = await api.get(url, { params, responseType: "blob" });
  const cd = r.headers?.["content-disposition"] || "";
  const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
  let name = fallbackName;
  if (m) {
    try { name = decodeURIComponent(m[1]); } catch { name = m[1]; }
  }
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href; a.download = name; a.rel = "noopener";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 30_000);
  return name;
}
